module.exports = __webpack_public_path__ + "static/media/archivo-v7-latin-regular.1311922f.woff2";